import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Player} from '../../../../domain/player';
import {FeedbackService} from '../../../feedback.service';

@Component({
    selector: 'sg-endquestion-feedback',
    templateUrl: './endquestion-feedback.component.html',
    styleUrls: ['./endquestion-feedback.component.scss']
})
export class EndquestionFeedbackComponent implements OnInit {

  @Input() players: Player[];
  @Output() endquestionsFeedbackChange = new EventEmitter();
  placeholder: string;
  feedback = '';

  constructor(
      private feedbackService: FeedbackService) {
  }

  ngOnInit() {
    this.placeholder = 'Schrijf hier jullie feedback ... ';
  }

  changePlaceholder() {
    if (this.placeholder != null && this.placeholder !== '') {
      this.placeholder = '';
    } else {
      this.placeholder = 'Schrijf hier jullie feedback ... ';
    }
  }

  get feedbackYN(): boolean {
    let bool = false;
    if (this.feedback != null) {
      if (this.feedback.length > 5) {
        bool = true;
      } else {
        bool = false;
      }
    }
    return bool;
  }

  sendFeedback() {
    if (confirm('Tevreden met de feedback en verzenden?')) {
      this.feedbackService.send(this.feedback).subscribe(() => {
        this.feedback = null;
      });
      this.endquestionsFeedbackChange.emit(true);
    } else {
      // terug naar feedback
    }
  }
}

